<script lang="ts" setup>
  import HostErrorMessage from './HostErrorMessage.vue';
</script>

<template>
  <HostErrorMessage title="Something went wrong">
    <p>An unexpected error occurred. This error has been reported. Please try again later.</p>
  </HostErrorMessage>
</template>
